module.exports = __webpack_public_path__ + "static/media/aboutMe.48bd1ba7.JPG";